<template>
    <div style="background: white">
        <AchievementsHeader/>
        <div class="breadBox">
            <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
                <a-breadcrumb-item @click="onRollback" style="cursor:pointer">通知公告</a-breadcrumb-item>
                <a-breadcrumb-item>通知公告详情</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="tabBox">
          <div class="title">{{noticeObj.title}}</div>
            <div class="subtitle">
                发布日期:{{noticeObj.publishTime}}
            </div>
            <div class="titlecontent" :style="{ fontSize: sizes + 'px' }" >{{noticeObj.title}}</div>
            <div class="content" :style="{ fontSize: sizes + 'px' }"  v-html="noticeObj.content"></div>
        </div>
    </div>

</template>
<script>
import AchievementsHeader from "./achievementsHeader"
import {noticeWeb} from "@/api/innovationService";

export default {
    name:"noticeDetail",
    components:{AchievementsHeader},
    data(){
        return{
            sizes:16,
            noticeObj:{}
        }
    },
    methods:{
        getDetail(){
            this.getAction({
                url:noticeWeb.detail,
                params:{id:this.$route.query.id}
            }).then(res=>{
                this.noticeObj= res
            })
        },
        onRollback(){
            this.$router.push({
                path:"/achievements/components/consultation",
                query:{
                    type:"资讯公告"
                }
            })
        },
        onRollbackHome(){
            this.$router.push({
                path:"/achievements/index",
                query:{
                    type:"首页"
                }
            })
        }
    },
    mounted() {
        this.getDetail()
    }
}
</script>
<style lang="less" scoped>
.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: white;
}
.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;
    .title{
        text-align: center;
        font-size: 30px;
        color: #333;
    }
    .subtitle{
        font-size: 14px;
        text-align: center;
        margin-top: 30px;
        padding-bottom: 20px;
        color: #333;
        border-bottom: 1px solid #ccc;
    }
    .titlecontent{
        text-align: center;
        font-size: 16px;
        margin-top: 60px;
        font-weight: 600;
        padding:0 10%;
        line-height: 40px;
    }
    .content{
        padding:0 10%;
        font-size: 16px;
        line-height: 30px;
        margin-top: 60px;
        text-indent: 30px;
        :deep(img){
            width:60%;
            margin-left: 18%;
            margin-bottom: 20px;
        }
        :deep(p){
            line-height: 40px;
        }
    }
}
</style>
